import React from 'react';

interface Link {
  children: React.ReactNode;
  href: string;
}

const Link = ({ children, href }: Link) => (
  <a
    className="whatcrm-widget-link"
    href={href}
    rel="noreferrer"
    target="_blank"
  >
    {children}
  </a>
);

export default Link;
